/**
 * Recursos de cada plano, exibidos na homepage e na página de planos. Uma fonte só para que as duas
 * nunca prometam coisas diferentes. Só liste o que o backend realmente aplica (ADR-001 e ADR-009).
 */
export const PRO_PRICE_LABEL = "R$ 24,90"
export const COUPLE_PRICE_LABEL = "R$ 44,90"
export const FAMILY_PRICE_LABEL = "R$ 79,90"

export const PLAN_FEATURES = {
  free: [
    "Painel com saldo, receitas e despesas",
    "Lançamentos sem limite",
    "2 contas bancárias e 1 cartão de crédito",
    "FinBot com 10 mensagens por mês",
    "Categorias e relatórios básicos",
    "Verificação em duas etapas",
  ],
  pro: [
    "Tudo do Free",
    "Contas, cartões e FinBot sem limite",
    "Importação de extratos OFX, CSV e PDF",
    "Orçamentos, metas e recorrências",
    "Investimentos e dívidas",
    "Análise com IA e categorização automática",
    "Relatórios avançados e calculadoras",
  ],
  // Planos de grupo (ADR-021): o titular assina e todos os membros têm o Pro
  couple: [
    "Tudo do Pro para 2 pessoas",
    "Carteira conjunta para as contas da casa",
    "Cada pessoa mantém a própria conta pessoal",
  ],
  family: [
    "Tudo do Pro para até 5 pessoas",
    "Carteira conjunta para as contas da casa",
    "Cada pessoa mantém a própria conta pessoal",
  ],
} as const
